import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { adsAPI, imagaeAPI, SportAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const SportNews = () => {
    // State
    const [loading, setLoading] = useState(false);

    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [error, setError] = useState(null);


    const [allcategories, setAllCategoriesNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchAllCategoryNews = async () => {
        setLoading(true);
        try {
            const res = await SportAPI.getAll();
            // Fix: res.data is the array directly
            setAllCategoriesNews(res.data);
        } catch (error) {
            console.error("Error fetching news:", error);
        } finally {
            setLoading(false);
        }
    };

    const leftCol = allcategories.slice(0, 20);





    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {

        fetchAllCategoryNews();

        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Sport
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-lg-8">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {leftCol.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">



                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">


                                            {ads.length > 0 && (

                                                <>


                                                    {ads.map((ad) => (

                                                        <div className="" key={ad.id}>

                                                            <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />

                                                        </div>

                                                    ))
                                                    }

                                                </>

                                            )}



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default SportNews;